const appSelector = '.normalize';
const rootElement = appSelector; //:root

export {appSelector, rootElement};
